const POSType = {
  SET_SELLER_WISE_PRODUCT_LIST: "SET_SELLER_WISE_PRODUCT_LIST",
  SET_ADD_TO_CART: "SET_ADD_TO_CART",
  GET_CART_LIST: "GET_CART_LIST",
  UPDATE_CART: "UPDATE_CART",
  REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
  ORDER_GENERATES: "ORDER_GENERATES",
  REMOVE_ALL_ITEM: "REMOVE_ALL_ITEM",
  GET_PRODUCT_VARIANT_DETAILS: "GET_PRODUCT_VARIANT_DETAILS",
  GET_PRODUCT_DETAILS: "GET_PRODUCT_DETAILS",
};
export interface GetSellerWiseProductList {
  limit: number;
  search: any;
  page: number;
}

export interface AddToCart {
  product_id: number;
  user_id: number;
  size: any;
  color: string;
  isVariant: string;
}

export interface GetCartList {
  user_id: number;
}

export interface UpdateCart {
  id: number;
  action: any;
  qty: number;
}

export interface RemoveCartItem {
  id: number;
}

export interface CreateOrder {
  user_id: number;
  deliveryCharge: number;
}

export interface RemoveAllItem {
  user_id: number;
}

export interface GetProductVariantDetails {
  product_id: number;
  size: any;
  color: string;
}

export interface GetProductDetails {
  product_id: number;
  slug: any;
}

export default POSType;
